import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  Alert
} from '@mui/material';
import {
  Warning as WarningIcon,
  Info as InfoIcon
} from '@mui/icons-material';

interface SessionTimeoutModalProps {
  isOpen: boolean;
  onExtendSession: () => void;
  onClose?: () => void;
}

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({
  isOpen,
  onExtendSession,
  onClose
}) => {
  return (
    <Dialog 
      open={isOpen} 
      maxWidth="sm" 
      fullWidth
      disableEscapeKeyDown
      onClose={onClose}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="warning" />
          <Typography variant="h6">
            Are you still there?
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Alert 
            severity="warning"
            icon={<InfoIcon />}
            sx={{ mb: 2 }}
          >
            <Typography variant="body1">
              Your session is about to expire due to inactivity. 
              Click the button below to stay logged in.
            </Typography>
          </Alert>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={onExtendSession}
          size="large"
          sx={{ minWidth: 120 }}
        >
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionTimeoutModal; 